const PROSE_LINK_CLASSNAMES =
  'prose-a:no-underline prose-a:text-brand-tertiary hover:prose-a:text-brand-secondary active:prose-a:text-brand-secondary hover:prose-a:underline';

export const MARKDOWN_CLASSNAMES = `max-w-none prose prose-headings:font-semibold prose-h1:text-2xl prose-h2:text-xl prose-h3:text-md prose-p:font-normal prose-hr:my-md prose-p:m-0 ${PROSE_LINK_CLASSNAMES} break-anywhere`;
